import React, { useState, useEffect } from "react";
import CodeMirror from '@uiw/react-codemirror';
import { html } from '@codemirror/lang-html';
import { githubLight } from '@uiw/codemirror-theme-github'
import "./CodeInput.css";

type CodeInputProps = {
    content: string;
    onContentChange: (content: string) => void;
  };

const CodeInput: React.FC<CodeInputProps> = ({ content, onContentChange }) => {
  const [code, setCode] = useState(content);

  const handleChange = React.useCallback((val:string) => {
    setCode(val);
    onContentChange(val)
  }, []);

  /*
  const handlePaste = (event) => {
    setCode(beauty(event.clipboardData.getData("text")));
    onContentChange(code)
  };
*/
/*
  useEffect(() => {
    setCode(content)
  },[])
*/
  return <CodeMirror value={code} height="450px" extensions={[html()]} onChange={handleChange} theme={githubLight} />
}

export default CodeInput;